import { type SVGProps, useId } from "react"

interface LandingArcProps extends SVGProps<SVGSVGElement> {
  className?: string
}

export function LandingArc({ className = "", ...props }: LandingArcProps) {
  const clipId = useId()
  const gradientId = useId()

  return (
    <svg
      width="1400"
      height="235"
      viewBox="0 0 1400 235"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Decorative arc shape"
      {...props}
    >
      <title>Decorative arc shape</title>
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M1399.93 233.66C1399.64 233.9 1399.35 234.14 1399.06 234.38C1263.62 93.44 983.19 23.03 699.97 23.51C416.74 23.03 136.31 93.44 0.87 234.38C0.58 234.14 0.29 233.9 0 233.66C139.73 50.88 480.44 1.83 697.75 0C698.49 0 699.23 0.01 699.97 0.02C700.71 0.02 701.45 0.01 702.19 0C919.49 1.83 1260.21 50.88 1399.94 233.66H1399.93Z"
          fill={`url(#${gradientId})`}
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="1399.93" height="234.38" fill="white" />
        </clipPath>
        <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="0">
          <stop stopColor="#001CFF" />
          <stop stopColor="#22FF65" offset="1" />
        </linearGradient>
      </defs>
    </svg>
  )
}
